import React from "react";
import { Divider, Form, Input, Row, Col, Tooltip, message } from 'antd';
import CustomBadge from 'components/CustomBadge';
import { config } from 'util/config';
import * as globalFunction from 'util/GlobalFunction';
import AntDraggableModal from 'components/AntDraggableModal';
import { httpClient } from "util/Api";

export default class JobNavigation extends React.Component {
  constructor(props) {
    super();
    this.state = {
      jobData: {},
      showWorkflow: false,
      showActionPack: false,
      mouseEvent: null,
      popUpLeft: 0,
      showLockJob: false,
      showUnlockJob: false,
      submitting: false,
      LapsedDate: '',
    }
  };

  //查询该页面的config
  async componentDidMount() {
    this.setState({ jobData: this.props.jobData, });
    this.setState({ LapsedDate: globalFunction.truncateString(this.props.jobData.BuildingPermit?.CompletedByDate, 10) })
  }

  render() {
    return (
      <>
        <div className="job-navigation" style={{ padding: '10px 36px 8px 36px' }}>
          {this.state.jobData.JobNum}
          <Divider type="vertical" />
          {
            globalFunction.isNullOrEmpty(this.state.jobData.WorkflowStatusDescription) ? <CustomBadge text={this.state.jobData.WorkflowStatusName} backgroundColor={this.state.jobData.WorkflowStatusBackgroundColor} /> :
              <Tooltip mouseEnterDelay={config.component.Tooltip.mouseEnterDelay} title={<span dangerouslySetInnerHTML={{ __html: this.state.jobData.WorkflowStatusDescription?.replace(/\n/g, '<br />') }}></span>}>
                <span><CustomBadge text={this.state.jobData.WorkflowStatusName} backgroundColor={this.state.jobData.WorkflowStatusBackgroundColor} /></span>
              </Tooltip >
          }
          <Divider type="vertical" />
          <span style={{ color: '#DC3545' }}>{this.state.jobData.PptAddress}</span>
          <Divider type="vertical" />
          <span style={{ color: '#038fde' }}>{globalFunction.truncateString(this.state.jobData.WorkDescription, 50, '...')}</span>
          {(!globalFunction.isNullOrEmpty(this.props.pageComponent.state?.page?.showApprovalLapseDate) && !globalFunction.isNullOrEmpty(this.state.LapsedDate)) ? (
            <>
              <Divider type="vertical" />
              <CustomBadge text={this.props.pageComponent.state?.page?.showApprovalLapseDate + ' ' + this.state.LapsedDate} backgroundColor={'#F44336'} />
            </>
          ) : <></>}
        </div>
      </>
    );
  }
}
